import { GraphColor, LocalGraphColour } from "../Colors";

const api = process.env.REACT_APP_API_URL;

export const urls = {
	quotaStatus: `${api}ApprovalQuotaModification/GetScenarioStatus`,
	userCountries: `${api}GetUserCountries?`,
   quotaForApproval: `${api}ApprovalQuotaModification/GetQuotaforApproval?`,
   popupGraph: `${api}ApprovalQuotaModification/GetPopUpGraphData?`,
   scenarioModificationList: 
   `${api}ApprovalQuotaModification/GetScenarioModificationList?`,
   Upload : `${api}Approve/Upload`,
   rejectMultiple: `${api}ApprovalQuotaModification/RejectQuotaMultiple?`,
   approve: `${api}ApprovalQuotaModification/ApproveQuotaMultiple?`,
   approveMulWithComment: `${api}ApprovalQuotaModification/ApproveQuotaMultipleComments?`,
   rejectSingle : `${api}ApprovalQuotaModification/RejectQuotaSingle`,
   approveSingle : `${api}ApprovalQuotaModification/ApproveQuota`,
   approveSingleWithComment : `${api}ApprovalQuotaModification/ApproveQuotaComments`,
   Downloadfile: `${api}Define/DownloadFile?`,
};

export const periods = [
	{ key: 1, value: "Current" },
	{ key: 0, value: "Previous" },
];


export function getQuotaModificationTableRows(data) {
   const rows = data?.map((item, index) =>{
      return {
         id: index,
         scenarioId: item.scenarioId,
         quotaId: item.quotaId,
         scenarioName: item.scenarioName,
         modificationStatus: item.modificationStatus,
         modifiedQuota: item.modifiedQuota, 
         previousQuota: item.previousQuota,
         differenceInQuota: item.differenceInQuota,
         lastActionDate: item.lastActionDate,
         lastActionBy: item.lastActionBy, 
         geoId: item.geoId,
      };
   });
   console.log("Approval_QuotaModification_getQuotaModificationTableRows", rows);
   for(let i=0; i< rows.length; i++){
      rows[i] = getApproveStatus(rows[i]);
   }
   return rows;
}
function  getApproveStatus (item){
	let modificationStatus = item.modificationStatus.toLowerCase();
	const logedUser = JSON.parse(localStorage.getItem("data"));
	if (logedUser.isAnalyst == true) {
		item['canApproveReject'] = false;
      item['canEdit'] = false;
	}
	else {
		if (modificationStatus == "approved" || modificationStatus == "rejected" || modificationStatus == "draft") {
		item['canApproveReject'] = false;
      item['canEdit'] = true;
		}
		else {
		if ((logedUser.isAdmin || (logedUser.isHQUser && logedUser.isApprover))) {
			if (modificationStatus == "normal modified" || modificationStatus == "shift modified" || modificationStatus == "locally approved") {
			item['canApproveReject'] = true;
         item['canEdit'] = false;
			}
		}
		else if (!logedUser.isHQUser) {
			if (modificationStatus == "normal modified" || modificationStatus == "shift modified") {
			item['canApproveReject'] = true;
         item['canEdit'] = false;
			}
			else if (modificationStatus == "locally approved") {
			item['canApproveReject'] = false;
         item['canEdit'] = false;
			}
		}
		}
	}
	return item;
  }

export function preparePopupGraphData(data) {
   // The api returns last 20 months data for each data source. So first 20 items are 
   // unique months
   const periods = data.slice(0, 20)?.map(item => item.period);
   const seriesData = [];
   const duplicateDataSources = data?.map(item => item.dataSourceName);
   const dataSources = Array.from(new Set(duplicateDataSources)); ;

   let start = 0, end = 20;
   for(let d = 0; d < dataSources.length; ++d) {
      const dataSource = dataSources[d];
      let values = [];
      for(let j = start; j < end; ++j) {
         values.push(data[j].value);
      }
      seriesData.push( { name: dataSource, data: values, } );
      start += 20;
      end += 20;
   }
   const duplicateDSForColor = data.map(item => ({
   dataSourceName: item.dataSourceName,
   datasourceID: item.datasourceID
   }));
   const uniqueSet = new Set(duplicateDSForColor.map(JSON.stringify));
   const dsr = Array.from(uniqueSet).map(JSON.parse);
   const color = [];
   for(let i = 0; i < dsr.length; ++i) {
      if(dsr[i].dataSourceName.toLowerCase().includes('ttm')){
         color.push(GraphColor.TTM);
      }else if(dsr[i].dataSourceName.toLowerCase().includes('mdr')){
         color.push(GraphColor.MDR);
      }else if(dsr[i].dataSourceName.toLowerCase().includes('ims')){
         color.push(GraphColor.IMS);
      }else if(dsr[i].dataSourceName.toLowerCase().includes('quota')){
         color.push(GraphColor.Quota);
      }else if(dsr[i].dataSourceName.toLowerCase().includes('le diagnostics')){
         color.push(GraphColor.LE);
      }else if(dsr[i].datasourceID > 5 && dsr[i].datasourceID < 50){
         color.push(LocalGraphColour[dsr[i].datasourceID]);
      }else{
         color.push("#16d620");
      }
   }
   
   const graphData = { periods, seriesData, color };
   console.log("Approval_QuotaModification_preparePopupGraphData", graphData);
   return graphData;
}

export function getScenarioModificationListRows(data, scenarioCanApproveReject) {
   if(data !== undefined && data !== null){
      const rows = data?.map((item, index) => {
         return {
            id: index, 
            scenarioId: item.scenarioId, 
            quotaId: item.quotaId, 
            modificationId: item.modificationId, 
            geoId: item.geoId, 
            modificationNo: item.modificationNo, 
            modificationStatus: item.modificationStatus, 
            differenceInQuota: item.differenceInQuota, 
            lastActionDate: item.lastActionDate,
            lastActionBy: item.lastActionBy, 
         };
      });
      for(let i=0; i< rows.length; i++){
         rows[i] = getApproveStatus_ModificationList(rows[i], scenarioCanApproveReject);
      }
      return rows;
   }
   return null;
}
function  getApproveStatus_ModificationList (item, scenarioCanApproveReject){
	let modificationStatus = item.modificationStatus.toLowerCase();
	const logedUser = JSON.parse(localStorage.getItem("data"));
	if (logedUser.isAnalyst == true) {
		item['canApproveReject'] = false;
      //item['canEdit'] = false;
	}
	else {
		if (modificationStatus == "approved" || modificationStatus == "rejected" || modificationStatus == "draft") {
		item['canApproveReject'] = false;
      //item['canEdit'] = true;
		}
		else {
		if (logedUser.isLocalUser && logedUser.isApprover && modificationStatus == "locally approved") {
			item['canApproveReject'] = false;
         //item['canEdit'] = false;
		}
      else{
         item['canApproveReject'] = scenarioCanApproveReject;
      }
		}
	}
	return item;
  }

export function getModificationPriorTableRows(priorData, latestData, displayModified, selectedModificationNumber) {
   let rows = [];
   if(!displayModified) {
      for(let i = 0; i < priorData.length; ++i) {
         const priorItem = priorData[i];
         if(selectedModificationNumber !==undefined && selectedModificationNumber !== null && selectedModificationNumber !== ""){
            if(priorItem.modificationNo === selectedModificationNumber){
               const item = {
                  id: i, 
                  modificationNo: priorItem.modificationNo, 
                  customerName: priorItem.customerName, 
                  number: priorItem.number, 
                  skuName: priorItem.skuName, 
                  skuNumb: priorItem.skuNumb, 
                  modification1: priorItem.modification1, 
                  modification2: priorItem.modification2, 
                  modification3: priorItem.modification3, 
                  modification4: priorItem.modification4, 
                  modification5: priorItem.modification5,
                  modificationComments : priorItem.modificationComments
               }
               rows.push(item);
            }
         }
         else{
            let length = latestData.length
            let lastModification = latestData[length-1].modificationNo;
            if(priorItem.modificationNo === lastModification){
               const item = {
                  id: i, 
                  modificationNo: priorItem.modificationNo, 
                  customerName: priorItem.customerName, 
                  number: priorItem.number, 
                  skuName: priorItem.skuName, 
                  skuNumb: priorItem.skuNumb, 
                  modification1: priorItem.modification1, 
                  modification2: priorItem.modification2, 
                  modification3: priorItem.modification3, 
                  modification4: priorItem.modification4, 
                  modification5: priorItem.modification5,
                  modificationComments : priorItem.modificationComments
               }
               rows.push(item);
            }
         }
      }
   }
   else {
      for(let i = 0; i < priorData.length; ++i) {
         const priorItem = priorData[i];
         const latestItem = latestData[i];

         const modified = priorItem.modification1 !== latestItem.modification1 ||
         priorItem.modification2 !== latestItem.modification2 ||
         priorItem.modification3 !== latestItem.modification3 ||
         priorItem.modification4 !== latestItem.modification4 ||
         priorItem.modification5 !== latestItem.modification5 || 
         priorItem.modificationComments !== latestItem.modificationComments;

         if(modified) {
            if(selectedModificationNumber !==undefined && selectedModificationNumber !== null && selectedModificationNumber !== ""){
               if(priorItem.modificationNo === selectedModificationNumber){
                  const item = {
                     id: i, 
                     modificationNo: priorItem.modificationNo, 
                     customerName: priorItem.customerName, 
                     number: priorItem.number, 
                     skuName: priorItem.skuName, 
                     skuNumb: priorItem.skuNumb, 
                     modification1: priorItem.modification1, 
                     modification2: priorItem.modification2, 
                     modification3: priorItem.modification3, 
                     modification4: priorItem.modification4, 
                     modification5: priorItem.modification5,
                     modificationComments : priorItem.modificationComments
                  }
                  rows.push(item);
               }
            }
            else{
               let length = latestData.length
               let lastModification = priorData[length-1].modificationNo;
               if(priorItem.modificationNo === lastModification){
                  const item = {
                     id: i, 
                     modificationNo: priorItem.modificationNo, 
                     customerName: priorItem.customerName, 
                     number: priorItem.number, 
                     skuName: priorItem.skuName, 
                     skuNumb: priorItem.skuNumb, 
                     modification1: priorItem.modification1, 
                     modification2: priorItem.modification2, 
                     modification3: priorItem.modification3, 
                     modification4: priorItem.modification4, 
                     modification5: priorItem.modification5,
                     modificationComments : priorItem.modificationComments
                  }
                  rows.push(item);
               }
            }
         }
      }
   }
   console.log("Approval_QuotaModification_getModificationPriorTableRows", rows);
   return rows;
}


export function getModificationLatestTableRows(priorData, latestData, displayModified, selectedModificationNumber) {
   let rows = [];
   if(!displayModified) {
      for(let i = 0; i < priorData.length; ++i) {
         const priorItem = priorData[i];
         const latestItem = latestData[i];
         if(selectedModificationNumber !==undefined && selectedModificationNumber !== null && selectedModificationNumber !== ""){
            if(latestData[i].modificationNo === selectedModificationNumber){
               const item = {
                  id: i, 
                  modificationNo: latestItem.modificationNo, 
                  customerName: latestItem.customerName, 
                  number: latestItem.number, 
                  skuName: latestItem.skuName, 
                  skuNumb: latestItem.skuNumb, 
                  modification1: latestItem.modification1, 
                  modification2: latestItem.modification2, 
                  modification3: latestItem.modification3, 
                  modification4: latestItem.modification4, 
                  modification5: latestItem.modification5,
                  priorModification1 : priorItem.modification1,
                  priorModification2 : priorItem.modification2,
                  priorModification3 : priorItem.modification3,
                  priorModification4 : priorItem.modification4,
                  priorModification5 : priorItem.modification5,
                  modificationComments : latestItem.modificationComments
               }
               rows.push(item);
            }
         }
         else{
            let length = latestData.length
            let lastModification = latestData[length-1].modificationNo;
            if(latestData[i].modificationNo ===lastModification){
               const item = {
                  id: i, 
                  modificationNo: latestItem.modificationNo, 
                  customerName: latestItem.customerName, 
                  number: latestItem.number, 
                  skuName: latestItem.skuName, 
                  skuNumb: latestItem.skuNumb, 
                  modification1: latestItem.modification1, 
                  modification2: latestItem.modification2, 
                  modification3: latestItem.modification3, 
                  modification4: latestItem.modification4, 
                  modification5: latestItem.modification5,
                  priorModification1 : priorItem.modification1,
                  priorModification2 : priorItem.modification2,
                  priorModification3 : priorItem.modification3,
                  priorModification4 : priorItem.modification4,
                  priorModification5 : priorItem.modification5,
                  modificationComments : latestItem.modificationComments
               }
               rows.push(item);
            }
         }
      }
   }
   else {
      for(let i = 0; i < priorData.length; ++i) {
         const priorItem = priorData[i];
         const latestItem = latestData[i];

         const modified = priorItem.modification1 !== latestItem.modification1 ||
         priorItem.modification2 !== latestItem.modification2 ||
         priorItem.modification3 !== latestItem.modification3 ||
         priorItem.modification4 !== latestItem.modification4 ||
         priorItem.modification5 !== latestItem.modification5 ||
         priorItem.modificationComments !== latestItem.modificationComments;

         if(modified) {
            if(selectedModificationNumber !==undefined && selectedModificationNumber !== null && selectedModificationNumber !== ""){
               if(latestData[i].modificationNo === selectedModificationNumber){
                  const item = {
                     id: i, 
                     modificationNo: latestItem.modificationNo, 
                     customerName: latestItem.customerName, 
                     number: latestItem.number, 
                     skuName: latestItem.skuName, 
                     skuNumb: latestItem.skuNumb, 
                     modification1: latestItem.modification1, 
                     modification2: latestItem.modification2, 
                     modification3: latestItem.modification3, 
                     modification4: latestItem.modification4, 
                     modification5: latestItem.modification5,
                     priorModification1 : priorItem.modification1,
                     priorModification2 : priorItem.modification2,
                     priorModification3 : priorItem.modification3,
                     priorModification4 : priorItem.modification4,
                     priorModification5 : priorItem.modification5,
                     modificationComments : latestItem.modificationComments
                  }
                  rows.push(item);
               }
            }else{
               let length = latestData.length
               let lastModification = latestData[length-1].modificationNo;
               if(latestData[i].modificationNo === lastModification){
                  const item = {
                     id: i, 
                     modificationNo: latestItem.modificationNo, 
                     customerName: latestItem.customerName, 
                     number: latestItem.number, 
                     skuName: latestItem.skuName, 
                     skuNumb: latestItem.skuNumb, 
                     modification1: latestItem.modification1, 
                     modification2: latestItem.modification2, 
                     modification3: latestItem.modification3, 
                     modification4: latestItem.modification4, 
                     modification5: latestItem.modification5,
                     priorModification1 : priorItem.modification1,
                     priorModification2 : priorItem.modification2,
                     priorModification3 : priorItem.modification3,
                     priorModification4 : priorItem.modification4,
                     priorModification5 : priorItem.modification5,
                     modificationComments : latestItem.modificationComments
                  }
                  rows.push(item);
               }
            }
         }
      }
   }
   console.log("Approval_QuotaModification_getModificationLatestTableRows", rows);
   return rows;
}
